/**
 * @module cercaliagl/MapTypes
 */

/**
 * Available styled maps.<br/>
 * It is possible to use an empty map, without any data, in this case you can use <code>cercaliagl.MapTypes.EMPTY</code>
 * <ul>
 * <li><b>cercaliagl.MapTypes.EMPTY</b></li>
 * <li><b>cercaliagl.MapTypes.CERCALIA</b></li>
 * <li><b>cercaliagl.MapTypes.SATELLITE</b></li>
 * <li><b>cercaliagl.MapTypes.OSM</b></li>
 * <li><b>cercaliagl.MapTypes.DARK`</b></li>
 * <li><b>cercaliagl.MapTypes.SILVER`</b></li>
 * <li><b>cercaliagl.MapTypes.BLANKMAP`</b></li>
 * <li><b>cercaliagl.MapTypes.GOOGLE_STYLE`</b></li>
 * <li><b>cercaliagl.MapTypes.GOOGLE_STYLE_V2`</b></li>
 * <li><b>cercaliagl.MapTypes.GOOGLE_STYLE_TRANSPARENT`</b></li>
 * </ul>
 * @type {Object.<string, string>}
 * @api
 */
const MapTypes = {
  /**
   * @api
   */
  EMPTY: 'Empty',
  /**
   * @api
   */
  CERCALIA: 'Cercalia',
  /**
   * @api
   */
  OSM: 'OSM',
  /**
   * @api
   */
  SATELLITE: 'Satellite',
  /**
   * @api
   */
  DARK: 'Dark',
  /**
   * @api
   */
  SILVER: 'Silver',
  /**
   * @api
   */
  BLANKMAP: 'BlankMap',
  /**
   * @api
   */
  GOOGLE_STYLE: 'GoogleStyle',
  /**
   * Google Blue style
   * @api
   */
  GOOGLE_STYLE_V2: 'GoogleBlue',
  /**
   * @api
   */
  GOOGLE_STYLE_TRANSPARENT: 'GoogleStyleTransparent',
};

export default MapTypes;
